import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage, uploadBytes } from "firebase/storage";
import {
  collection,
  getFirestore,
  setDoc,
  doc,
  Timestamp,
  getDocs,
  orderBy,
  query,
  where,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  getCountFromServer,
} from "firebase/firestore";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBnEdCwZCEh_eG-TnHLiVxfwiHZNG_GuSU",
  authDomain: "ncafiles-6e036.firebaseapp.com",
  databaseURL: "https://ncafiles-6e036-default-rtdb.firebaseio.com",
  projectId: "ncafiles-6e036",
  storageBucket: "ncafiles-6e036.appspot.com",
  messagingSenderId: "760276261464",
  appId: "1:760276261464:web:24c12a7163c8a0ddda882d",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
// Portal data lives in the dedicated `nca-portal` Firestore database, split out
// of the shared `(default)` database used by the public NCA site.
export const db = getFirestore(app, "nca-portal");

// Firestore functions

const logsCollections = collection(db, "logs");
const indexCollection = collection(db, "index");

export function addLog(userEmail, fileName, activity) {
  return setDoc(doc(logsCollections), {
    Filename: fileName,
    Email: userEmail,
    Time: Timestamp.fromDate(new Date()),
    Activity: activity,
  });
}

export async function getLogsByEmail(email) {
  const q = query(logsCollections, where("Email", "==", email));
  const data = await getDocs(q);
  var exports = [];
  data.forEach((doc) => {
    exports.push([
      doc.data().Filename,
      doc.data().Email,
      doc.data().Time ? doc.data().Time.toDate().toISOString() : "",
      doc.data().Activity,
    ]);
  });
  exports.sort((a, b) => {
    const timeB = new Date(b[2]).getTime() || 0;
    const timeA = new Date(a[2]).getTime() || 0;
    return timeB - timeA;
  });
  return exports;
}
export async function getLogsByFilename(filename) {
  const q = query(logsCollections, where("Filename", "==", filename));
  const data = await getDocs(q);
  var exports = [];
  data.forEach((doc) => {
    exports.push([
      doc.data().Filename,
      doc.data().Email,
      doc.data().Time ? doc.data().Time.toDate().toISOString() : "",
      doc.data().Activity,
    ]);
  });
  exports.sort((a, b) => {
    const timeB = new Date(b[2]).getTime() || 0;
    const timeA = new Date(a[2]).getTime() || 0;
    return timeB - timeA;
  });
  return exports;
}

export async function getLogs({
  cursor = null,
  direction = "next",
  pageSize = 25,
} = {}) {
  const constraints = [orderBy("Time", "desc")];

  if (direction === "next") {
    if (cursor) {
      constraints.push(startAfter(cursor));
    }
    constraints.push(limit(pageSize));
  } else {
    if (!cursor) {
      return getLogs({ pageSize });
    }
    constraints.push(endBefore(cursor));
    constraints.push(limitToLast(pageSize));
  }

  const q = query(logsCollections, ...constraints);
  const snapshot = await getDocs(q);

  const entries = snapshot.docs.map((docSnap) => {
    const data = docSnap.data();
    return [
      data.Filename,
      data.Email,
      data.Time ? data.Time.toDate().toISOString() : "",
      data.Activity,
    ];
  });

  return {
    entries,
    firstDoc: snapshot.docs[0] || null,
    lastDoc: snapshot.docs[snapshot.docs.length - 1] || null,
    hasNext: snapshot.docs.length === pageSize,
  };
}

export async function getFilesIndex() {
  const q = query(indexCollection);
  const data = await getDocs(q);
  return data;
}

export async function getLogsCount() {
  const snapshot = await getCountFromServer(query(logsCollections));
  return snapshot.data().count || 0;
}
export async function uploadFilesTask(ref, file) {
  // console.log(ref);
  await setDoc(doc(indexCollection), {
    filename: ref.name,
    location: ref.parent.fullPath,
  });
  return uploadBytes(ref, file);
}
export async function uploadImagesFolder(ref) {
  await setDoc(doc(indexCollection), {
    filename: ref.name,
    location: ref.fullPath,
  });
}
export async function uploadImagesTask(ref, file) {
  // console.log(ref);
  return uploadBytes(ref, file);
}
export default app;
